import {useState, useEffect} from "react"
import {Document, Page, pdfjs} from "react-pdf"
import {useSelector} from "react-redux"
import SliderDots from "routes/weekly-ads/WeeklySingleAds/SliderDots"

import "./pdf_file_view.scss"
import {useApiDefaults} from "hooks/useApiDefaults"

const AnalysisIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 22V5M9 16l7 7l7-7M9 27h14"
    />
  </svg>
)

function PDFFileView({section}) {
  const [numPages, setNumPages] = useState()
  const {RSAClientId} = useApiDefaults()

  function onDocumentLoadSuccess(e) {
    setNumPages(e._pdfInfo?.numPages)
  }

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`
  }, [])

  if (!section.image) {
    return null
  }

  if (RSAClientId === 323) {
    return (
      <RenderPDFViewer
        onDocumentLoadSuccess={onDocumentLoadSuccess}
        numPages={numPages}
      />
    )
  }

  return (
    <PDFViewer
      section={section}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      numPages={numPages}
    />
  )
}

function PDFViewer({section, onDocumentLoadSuccess, numPages}) {
  const [pageNumber, setPageNumber] = useState(1)

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset)
  }

  function previousPage() {
    changePage(-1)
  }

  function nextPage() {
    changePage(1)
  }

  return (
    <Container>
      <div className="main-container  pdf-canvas-item">
        <div className="button-container main-pdf-wrap">
          <div className="btn">
            <button
              type="button"
              disabled={pageNumber <= 1}
              onClick={previousPage}
              className="Pre"
            >
              Previous
            </button>
            <button
              type="button"
              disabled={pageNumber >= numPages}
              onClick={nextPage}
            >
              Next
            </button>
          </div>
          <span>
            Page {pageNumber || (numPages ? 1 : "--")} / {numPages || "--"}
          </span>
        </div>
        <div className="pdf-container">
          <div className="pdf-inner">
            <Document
              file={section.image}
              onLoadSuccess={onDocumentLoadSuccess}
            >
              <Page pageNumber={pageNumber} />
            </Document>
          </div>
        </div>
      </div>
    </Container>
  )
}

function RenderPDFViewer({onDocumentLoadSuccess, numPages}) {
  const [pageNumber, setPageNumber] = useState(1)
  const customPageData = useSelector(
    ({customPage}) => customPage?.customPageData
  )
  const pdfUrls = (customPageData?.custom_page_section_arr ?? [])
    ?.filter(i => i.image)
    ?.map(i => ({title: i.title, url: i.image}))
  const [selectedPdfUrl, setSelectedPdfUrl] = useState(
    pdfUrls?.length ? pdfUrls[0]?.url : ""
  )

  function handleThumbnailClick(page) {
    setPageNumber(page)
  }

  const dots = Array.from({length: numPages || 0}, (_, i) => i + 1)
  const handleActiveDot = dot => {
    setPageNumber(dot)
  }

  const onPrev = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1)
    }
  }

  const onNext = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1)
    }
  }

  return (
    <Container>
      <div className="button-container">
        <div className="store-list">
          <label for="storeSelect">Select title:</label>
          <select
            id="storeSelect"
            name="storeSelect"
            onChange={e => setSelectedPdfUrl(e.target.value)}
            value={selectedPdfUrl}
          >
            {pdfUrls.map(({title, url}) => (
              <option value={url} key={url}>
                {title}
              </option>
            ))}
          </select>
        </div>

        {numPages > 0 && (
          <SliderDots
            pages={dots.length}
            activeSlide={pageNumber}
            handleActiveDot={handleActiveDot}
            onPrev={onPrev}
            onNext={onNext}
          />
        )}

        <button type="button" className="download-btn">
          <AnalysisIcon /> Download PDF
        </button>
      </div>

      <div className="pdf-split-container">
        <div className="pdf-Left">
          <Document file={selectedPdfUrl}>
            <Page pageNumber={pageNumber} />
          </Document>
        </div>
        <div className="pdf-right">
          <div className="pdf-container">
            <div className="pdf-inner">
              <Document
                file={selectedPdfUrl}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <div
                    key={`page_${index + 1}`}
                    className={`thumbnail ${
                      pageNumber === index + 1 ? "active" : ""
                    }`}
                    onClick={() => handleThumbnailClick(index + 1)}
                    style={{cursor: "pointer"}}
                  >
                    <Page pageNumber={index + 1} width={150} />
                  </div>
                ))}
              </Document>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

function Container({children}) {
  return (
    <div className="pdf-viewer pdf-canvas">
      <div className="container">{children}</div>
      <style>
        {`
          .react-pdf__Page__textContent {
              display: none !important;
          }
          .react-pdf__Page__annotations{
            display: none !important;
          }
      `}
      </style>
    </div>
  )
}

export default PDFFileView
